<div class="container-body">
  <div class="background-color"></div>
</div>
<navaar-header [color]="'transparent'" [z-index]="2"></navaar-header>

<ng-container
        [ngTemplateOutlet]="hasAlreadySubscription === null ? LOADING_PLANS : hasAlreadySubscription ? has_subscription : plan_select_tmp"></ng-container>
<!--<ng-container [ngTemplateOutlet]="selectedRecurring ? recurring_select_temp : plan_select_tmp"></ng-container>-->

<ng-template #LOADING_PLANS>
  <div id="loading-plans">
    <navaar-indicator [isShowLoading]="true"></navaar-indicator>
  </div>
</ng-template>

<ng-template #has_subscription>
  <div class="wrapper wrapper-tittle-back-url" id="has-subscription">
    <h2> خرید اشتراک {{ appParametersService.appName }} </h2>
    <p>شما اشتراک فعال دارید و امکان رزرو وجود ندارد</p>
  </div>
</ng-template>

<ng-template #plan_select_tmp>
  <div class="wrapper wrapper-tittle-back-url">
    <h2> خرید اشتراک {{ appParametersService.appName }} </h2>
    <p class="title-desc"> :با خرید اشتراک {{ appParametersService.appName }} این امکانات را خواهید داشت</p>
    <div style="margin-top: 22px;">
      <ul>
        <li>
          <span>دسترسی به همه‌ی کتاب‌های صوتی</span>
        </li>
        <li>
          <span>دسترسی به همه خلاصه کتاب‌ها و سریال‌های صوتی</span>
        </li>
        <li>
          <span>ترافیک اینترنت به صورت نیم بها، روی همه‌ی اپراتورها</span>
        </li>
        <li *ngIf="device.isIOS() || device.isAndroid()">
          <span>امکان دانلود محتوا به صورت آفلاین</span>
        </li>
      </ul>
      <div class="container">
        <div class="container-items">
          <ng-template ngFor [ngForOf]="subscriptionPlansSimple" let-item>
            <div class="wrapper-items" (click)="onClickItem(item)"
                 [ngClass]="{'popular-plan': item.popularPlan, 'normal-plan': !item.popularPlan}"
                 [class]="item.themeColor">
              <div class="discount-section" *ngIf="item.product?.discount !== null">
                <span>%{{ item.product?.discount.promotionValue * 100 }}</span>&nbsp;
                <span>تخفیف</span>
              </div>
              <div class="header-item">
                <h3 [textContent]="item.durationAmountTitle"></h3>
                <h4 [textContent]="item.durationUnitTitle"></h4>
              </div>
              <div class="wrapper-title">
                <ng-template [ngIf]="item.product?.discount === null" [ngIfElse]="has_discount">
                  <b>
                    {{ item.product.discountedPrice > 0 ? ( ( item.product.discountedPrice / 10 ) | number: '3.' ) : 'رایگان' }}
                    <ng-template [ngIf]="item.product.discountedPrice > 0">
                      <small>تومان</small>
                    </ng-template>
                  </b>
                </ng-template>
                <ng-template #has_discount>
                  <b>
                    <div class="status-has-discounted">
                          <span class="main-price">
                            {{ item.product.price > 0 ? ( ( item.product.price / 10 ) | number: '3.' ) : 'رایگان' }}
                          </span>
                          <span class="has-discounted">
                                   {{ item.product.discountedPrice > 0 ? ( ( item.product.discountedPrice / 10 ) | number: '3.' ) : 'رایگان' }}
                            <ng-template [ngIf]="item.product.discountedPrice > 0">
                                <small>تومان</small>
                            </ng-template>
                          </span>
                    </div>
                  </b>
                </ng-template>
              </div>
            </div>
          </ng-template>
          <ng-template [ngIf]="subscriptionPlansRecurring?.length > 0 && hasRecurring">
            <!--            <ng-template ngFor [ngForOf]="subscriptionPlansRecurring" let-item>-->
            <!--              <div class="wrapper-items full-width" (click)="onClickRecurringItem(item)">-->
            <!--                <div class="discount-section" *ngIf="item.product?.discount !== null">-->
            <!--                  <span>%{{ item.product?.discount.promotionValue * 100 }}</span>&nbsp;-->
            <!--                  <span>تخفیف</span>-->
            <!--                </div>-->
            <!--                <div class="wrapper-list-item-full-width">-->
            <!--                  <div class="header-item-recurring" [class]="item.themeColor">-->
            <!--                    <p>-->
            <!--                      <img [src]="item.planIconPath">-->
            <!--                      <span [innerHTML]="item.description"></span>-->
            <!--                    </p>-->
            <!--                    <p [innerHTML]="item.title"></p>-->
            <!--                  </div>-->
            <!--                  <div class="wrapper-title">-->
            <!--                    <ng-template [ngIf]="item.product?.discount === null" [ngIfElse]="has_discount">-->
            <!--                      <b>-->
            <!--                        {{ item.product.discountedPrice > 0 ? ((item.product.discountedPrice / 10) | number: '3.') : 'رایگان'  }}-->
            <!--                        <small>تومان</small>-->
            <!--                      </b>-->
            <!--                    </ng-template>-->
            <!--                    <ng-template #has_discount>-->
            <!--                      <b>-->
            <!--                        <div class="status-has-discounted">-->
            <!--                       <span class="has-discounted">-->
            <!--                      {{ item.product.discountedPrice > 0 ? ((item.product.discountedPrice / 10) | number: '3.') : 'رایگان' }}-->
            <!--                    </span>-->
            <!--                          <span class="main-price">-->
            <!--                      {{ item.product.price > 0 ? ((item.product.price / 10) | number: '3.') : 'رایگان' }}-->
            <!--                    </span>-->
            <!--                        </div>-->
            <!--                        <small>تومان</small>-->
            <!--                      </b>-->
            <!--                    </ng-template>-->
            <!--                  </div>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </ng-template>-->
          </ng-template>
        </div>
      </div>
      <div>
        <p (click)="navigateToHowUse()" class="link-how-use">مطالعه شرایط استفاده</p>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #recurring_select_temp>
  <div (click)="onBackKeyButton()" id="back-click-coontainer"></div>
  <div class="container-selected-recurring">
    <div>
      <img [src]="selectedRecurring.planIconPath">
      <h2 [innerHTML]="selectedRecurring.description"></h2>
      <p class="title-desc">با فعال سازی این ویژگی می‌توانید بدون نیاز به وارد کردن مکرر اطلاعات کارت بانکی، بطور
        ماهیانه اشتراک خود را تمدید کنید. این شیوه پرداخت کاملا امن است و امکان لغو آن هر زمان که
        بخواهید از طریق آپ وجود دارد.</p>
      <div id="container-list-banks">
        <h3>بانکهای طرف قرارداد:</h3>
        <p>ملی، ملت، سامان، کشاورزی، مهرایران، پست بانک، اقتصادنوین، سرمایه، سینا، ایران زمین و دی</p>
      </div>
      <div class="wrapper-btn-active-recurring">
        <navaar-button
                [type-button]="'button'"
                [color-name]="'blue'"
                (onClick)="activeRecurring()"
                [disabled]="selectedRecurring &&  isLoadingBtn"
                [isShowLoader]="isLoadingBtn"
        >
          <p>فعالسازی</p>
        </navaar-button>
      </div>
    </div>
  </div>
</ng-template>
